<template>
    <el-dialog
        title="เพิ่มผู้ใช้งานระบบ"
        v-loading="isLoading"
        :visible.sync="show"
        width="672px"
    >
        <div>
            <el-form
                ref="formEmployee"
                :model="formEmployee"
                :rules="ruleCreateEmployee"
                label-position="left"
                label-width="160px"
            >
                <el-form-item label="ชื่อ" prop="firstName">
                    <el-input
                        v-model="formEmployee.firstName"
                        placeholder="กรอกชื่อ"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="นามสกุล" prop="lastName">
                    <el-input
                        v-model="formEmployee.lastName"
                        placeholder="กรอกนามสกุล"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="อีเมล" prop="email">
                    <el-input
                        v-model="formEmployee.email"
                        placeholder="กรอกอีเมล ตัวอย่าง example@fillgoods.co"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    class="password-box"
                    label="รหัสผ่าน"
                    prop="password"
                >
                    <div class="password-box__inner">
                        <el-input
                            :type="typePassword"
                            v-model="formEmployee.password"
                            :class="{ 'hide-password': !isShowPassword }"
                            autocomplete="off"
                            disabled
                        ></el-input>
                        <el-button
                            :disabled="
                                formEmployee.password === this.defaultPassword
                                    ? true
                                    : false
                            "
                            class="switch-btn"
                            type="text"
                            @click="isShowPassword = !isShowPassword"
                            >{{ isShowPassword ? "ซ่อน" : "แสดง" }}</el-button
                        >
                    </div>

                    <el-button
                        v-if="isEdit"
                        class="random-btn"
                        type="primary"
                        @click="randomPassword"
                        >รีเซ็ตรหัสผ่าน</el-button
                    >
                </el-form-item>
                <el-form-item label="ตำแหน่ง" prop="roleId">
                    <el-select
                        v-model="formEmployee.roleId"
                        placeholder="เลือกตำแหน่ง"
                    >
                        <el-option
                            v-for="item in roleList"
                            :key="item.roleId"
                            :label="item.description"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="สถานะ" prop="isActive">
                    <div
                        class="switch-box"
                        :class="{ 'close-color': !formEmployee.isActive }"
                    >
                        <el-switch
                            v-model="formEmployee.isActive"
                            active-color="#26AA5D"
                        >
                        </el-switch>
                        <div>
                            {{ formEmployee.isActive ? "เปิดใช้งาน" : "ปิด" }}
                        </div>
                    </div>
                </el-form-item>
                <div class="line-body"></div>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="show = false" plain>ยกเลิก</el-button>
            <el-button type="primary" @click="submitForm('formEmployee')"
                >บันทึก</el-button
            >
        </div>
    </el-dialog>
</template>
<script>
import fgApi from '@/services/fillgoods'
import { mapState } from 'vuex'
export default {
    name: 'ModalEmployeeForm',
    props: {
        isDialog: {
            type: Boolean,
            default: true
        },
        isEdit: {
            // กดจาก create = 0 or edit = 1
            type: Boolean,
            default: false
        },
        dataEmployee: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.objUser
        }),
        show: {
            get () {
                if (!this.isEdit) {
                    this.randomPassword()
                }
                return this.isDialog
            },
            set (val) {
                this.cancelForm()
            }
        },
        typePassword () {
            if (!this.isShowPassword) {
                return 'password'
            } else {
                return 'text'
            }
        }
    },
    data () {
        let validateFirstname = (rule, value, callback) => {
            if (value) {
                const stringReg = /[^\u0E00-\u0E7Fa-zA-Z\s]|[\u0E3F\u0E51-\u0E59]/g.test(
                    this.formEmployee.firstName
                )
                if (stringReg) {
                    callback(
                        new Error('ไม่อนุญาตให้ใส่อักขระพิเศษ หรือ Emoji')
                    )
                }
                callback()
            }
        }
        let validateLastname = (rule, value, callback) => {
            if (value) {
                const stringReg = /[^\u0E00-\u0E7Fa-zA-Z\s]|[\u0E3F\u0E51-\u0E59]/g.test(
                    this.formEmployee.lastName
                )
                if (stringReg) {
                    callback(
                        new Error('ไม่อนุญาตให้ใส่อักขระพิเศษ หรือ Emoji')
                    )
                }
                callback()
            }
        }
        let validatorEmail = (rule, value, callback) => {
            if (value) {
                const specReg = /`/g.test(
                    this.formEmployee.email
                )
                // const domainReg = /[^`]@fillgoods.co$/g.test(
                const domainReg = /@fillgoods.co$/g.test(
                    this.formEmployee.email
                )
                // console.log('bbbbb', domainReg)
                if (specReg || !domainReg) {
                    callback(new Error('ไม่อนุญาตให้ใส่อักขระพิเศษ ` หรือ ต้องเป็นอีเมลของบริษัทเท่านั้น'))
                }
                if (this.arrValidate.length > 0) {
                    this.arrValidate.map(item => {
                        if (item.field === 'email') {
                            callback(new Error(item.message))
                        }
                    })
                }
                callback()
            }
        }
        return {
            defaultPassword: '12345678',
            formEmployee: {
                firstName: '',
                lastName: '',
                email: '',
                password: null,
                roleId: '',
                isActive: true
            },
            roleList: [],
            ruleCreateEmployee: {
                firstName: [
                    {
                        required: true,
                        message: 'กรุณากรอกชื่อ',
                        trigger: 'blur'
                    },
                    {
                        validator: validateFirstname,
                        trigger: ['blur', 'change']
                    }
                ],
                lastName: [
                    {
                        required: true,
                        message: 'กรุณากรอกนามสกุล',
                        trigger: 'blur'
                    },
                    {
                        validator: validateLastname,
                        trigger: ['blur', 'change']
                    }
                ],
                email: [
                    {
                        required: true,
                        message: 'กรุณากรอกอีเมล',
                        trigger: 'blur'
                    },
                    {
                        validator: validatorEmail,
                        trigger: ['blur', 'change']
                    }
                ],
                roleId: [
                    {
                        required: true,
                        message: 'กรุณาเลือกตำแหน่ง',
                        trigger: ['blur', 'change']
                    }
                ]
            },
            isShowPassword: false,
            arrValidate: [],
            isLoading: false
        }
    },
    created () {
        this.getEmployeeRole()
    },
    methods: {
        submitForm (formName) {
            this.$refs[formName].validate(valid => {
                const {
                    isActive,
                    password,
                    email,
                    emailOld
                } = this.formEmployee
                const data = {
                    ...this.formEmployee,
                    email: emailOld === email ? null : email,
                    editor_email: this.user.email,
                    editor_value: null,
                    disable: !isActive,
                    password:
                        password === this.defaultPassword ? null : password
                }
                if (valid) {
                    this.isLoading = true
                    if (this.isEdit) {
                        this.editEmployee(data)
                    } else {
                        this.createEmployee(data)
                    }
                } else {
                    return false
                }
            })
        },
        cancelForm () {
            this.$swal({
                title: 'ออกจากหน้านี้',
                text: 'คุณต้องการออกจากหน้านี้โดยไม่บันทึกข้อมูลใช่หรือไม่',
                icon: 'warning',
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'ไม่ใช่',
                confirmButtonText: 'ใช่',
                reverseButtons: true,
                iconHtml: `<img src="${require('@/assets/swal-icons/status.svg')}" />`,
                customClass: {
                    container: 'oms-swal'
                }
            }).then(val => {
                if (val.isConfirmed) {
                    this.resetField()
                    this.$emit('close', false)
                    this.$emit('cancelEdit', false)
                } else {
                    return false
                }
            })
        },
        randomPassword () {
            let charsStr = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP'
            let chersNum = '1234567890'
            let passStr = ''
            let passNum = ''
            for (let i = 0; i < 4; i++) {
                let a = Math.floor(Math.random() * charsStr.length)
                passStr += charsStr.charAt(a)

                let b = Math.floor(Math.random() * passNum.length)
                passNum += chersNum.charAt(b)
            }
            this.formEmployee.password = passStr + passNum
        },
        resetField () {
            this.$refs.formEmployee.resetFields()
            this.isShowPassword = false
        },
        async getEmployeeRole () {
            const {
                success,
                data
            } = await fgApi.userManagement.getEmployeeRole()
            if (success) {
                this.roleList = data
            }
        },
        async createEmployee (val) {
            try {
                const { success } = await fgApi.userManagement.createEmployee(
                    val
                )
                if (success) {
                    this.isLoading = false
                    this.$message.success('บันทึกข้อมูลสำเร็จ')
                    this.resetField()
                    this.$emit('close', false)
                    this.$emit('isSuccess', true)
                }
            } catch (err) {
                this.isLoading = false
                console.log('something was wrong!', err)
                // let arr = []
                if (err.status === 409) {
                    err.data.errors.forEach(el => {
                        this.arrValidate.push({ ...el })
                        this.$refs.formEmployee.validateField(el.field)
                    })
                } else {
                    this.$message.error(
                        'บันทึกข้อมูลไม่สำเร็จ กรุณาทำรายการใหม่อีกครั้ง'
                    )
                }
            }
        },
        async editEmployee (data) {
            try {
                const { success } = await fgApi.userManagement.editEmployee(
                    data
                )
                if (success) {
                    this.isLoading = false
                    this.$message.success('บันทึกข้อมูลสำเร็จ')
                    this.resetField()
                    this.$emit('close', false)
                    this.$emit('cancelEdit', false)
                    this.$emit('isSuccess', true)
                }
            } catch (err) {
                this.isLoading = false
                if (err.status === 409) {
                    err.data.errors.forEach(el => {
                        this.arrValidate.push({ ...el })
                        this.$refs.formEmployee.validateField(el.field)
                    })
                } else {
                    this.$message.error(
                        'บันทึกข้อมูลไม่สำเร็จ กรุณาทำรายการใหม่อีกครั้ง'
                    )
                }
            }
        }
    },
    watch: {
        isEdit: {
            // open modal for edit
            handler (val) {
                this.$nextTick(() => {
                    this.resetField()
                    if (val) {
                        const { disable, email } = this.dataEmployee
                        this.formEmployee = {
                            ...this.dataEmployee,
                            isActive: !disable,
                            emailOld: email,
                            password: this.defaultPassword
                        }
                    }
                })
            },
            immediate: true
        },
        formEmployee: {
            handler () {
                this.arrValidate = []
            },
            deep: true
        }
    }
}
</script>
<style lang="scss" scoped>
.password-box {
    max-height: 40px;
    &__inner {
        position: relative;
        display: flex;
        width: 100%;
    }
    .el-button {
        font-weight: 400;
    }
    ::v-deep .hide-password {
        .el-input__inner {
            font-size: 27px;
        }
    }
    ::v-deep .el-input.is-disabled {
        .el-input__inner {
            color: $dark;
            opacity: 1 !important;
        }
    }
    .switch-btn {
        position: absolute;
        right: 15px;
    }
    .random-btn {
        min-width: 126px;
        height: 40px;
        margin-left: 16px;
    }
    ::v-deep .el-form-item__content {
        display: flex;
    }
}
.switch-box {
    display: flex;
    align-items: center;
    color: $green;
    &.close-color {
        color: $gray;
    }
    .el-switch {
        margin-right: 15px;
    }
}
.line-body {
    width: 100%;
    height: 1px;
    background-color: #e4e6ee;
}
::v-deep .el-dialog {
    border-radius: 4px;
    &__body {
        padding: 24px 88px 0px 24px !important;
    }
    &__header {
        display: flex;
        background-color: $primary-color;
        padding: 10px 24px;
    }
    &__title {
        color: white;
        font-weight: 500;
    }
    &__headerbtn {
        font-size: 20px;
        top: unset;
        .el-dialog__close {
            color: white;
        }
    }
    &__footer {
        padding: 20px 88px 25px 24px !important;
        .el-button {
            min-width: 88px;
            &.is-plain {
                border-color: $primary-color;
                color: $primary-color;
            }
        }
    }
    .el-select {
        width: 100%;
        .el-input {
            &__suffix {
                right: 8px;
            }
            .el-select__caret {
                font-family: "Material Icons" !important;
                font-size: 24px;
                color: $gray;
                &.el-icon-arrow-up {
                    &:before {
                        content: "\e5ce";
                    }
                }
            }
        }
    }
    .el-form-item {
        transition: all 0.3s ease;
        &__error {
            position: relative;
            padding-top: 8px;
            transition: all 0.3s ease;
        }
        &__content {
            text-align: left;
            transition: height 1s ease;
        }
        &.is-required:not(.is-no-asterisk) > .el-form-item__label {
            &:before {
                content: none;
            }
            &:after {
                content: "*";
                color: #f56c6c;
                margin-left: 4px;
            }
        }
    }
}
</style>
